import { env } from "@/env";
import { api } from "@/shared/api/api";
import { getPayloadUser } from "@/shared/auth/getPaylodUser";
import { notification } from "antd";
import { AxiosError } from "axios";
import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";

export const oidcConfig: AuthProviderProps = {
  authority: env.REACT_APP_URL_LOGIN,
  client_id: env.REACT_APP_CLIENT_ID,
  redirect_uri: env.REACT_APP_REDIRECT_URI,
  loadUserInfo: true,
  accessTokenExpiringNotificationTimeInSeconds: 10,
  automaticSilentRenew: true,
  silentRequestTimeoutInSeconds: 10,
  silent_redirect_uri: env.REACT_APP_REDIRECT_URI + "/inicio",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: async (user) => {
    if (!user) {
      notification.error({
        placement: "top",
        message: "Não foi possivel acessar o sistema",
        description: "Usuário não autenticado",
      });
      return;
    }

    const accessToken = user.access_token || "";
    const infoUser = getPayloadUser(accessToken);

    if (!infoUser?.cpf) {
      notification.error({
        placement: "top",
        message: "Não foi possivel acessar o sistema",
        description: "Erro ao obter informações do usuário",
      });
      return;
    }

    try {
      await api.get(`/usuarios/me`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      window.location.href = `${env.REACT_APP_REDIRECT_URI}/inicio`;
    } catch (error) {
      console.error("Erro ao verificar permissões:", error);

      if (error instanceof AxiosError) {
        if (!error.response?.data) {
          notification.error({
            placement: "top",
            message: "Não foi possivel acessar o sistema",
            description:
              "Inspeção Mobile se encontra indisponível no momento, tente novamente mais tarde.",
          });
        } else {
          notification.error({
            placement: "top",
            message: "Não foi possivel acessar o sistema",
            description:
              error.response.data.detail || "Erro ao verificar permissões",
          });
        }
      }

      const userManager = new UserManager({
        authority: env.REACT_APP_URL_LOGIN,
        client_id: env.REACT_APP_CLIENT_ID,
        redirect_uri: env.REACT_APP_REDIRECT_URI,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
      });

      await userManager.removeUser();

      await userManager.signoutSilent();
      window.location.href = env.REACT_APP_REDIRECT_URI;
    }
  },
};
